import React from 'react';
import { Tag, TagProps, useMultiStyleConfig } from '@chakra-ui/react';
import { QColorVariant } from '../../QTypes';

export type QCounterProps = TagProps & {
  count: number;
  variant?: QColorVariant | 'default' | 'outline' | 'white' | 'invertedRed';
  size: 'sm' | 'md';
};

export const QCounter: React.FC<QCounterProps> = ({
  count,
  variant = 'default',
  size = 'sm',
  ...rest
}) => {
  const styles = useMultiStyleConfig('Counter', { variant, size });

  if (count <= 0) {
    return null;
  }

  return (
    <Tag sx={styles} {...rest}>
      {count}
    </Tag>
  );
};

QCounter.displayName = 'QCounter';
